import styled from 'styled-components'

export const FooterTrocaLab = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  padding-top: 16px;
`
